"use strict";
globalThis.Bottomsheet = (() => {
  const { $ } = Utils;
  let els = null;
  let state = {
    isOpen: false,
    isDragging: false,
    startY: 0,
    currentY: 0,
    previousFocus: null,
    onCloseCallback: null
  };
  const init = () => {
    if (els) return;
    els = {
      backdrop: $("#bottomsheet-backdrop"),
      container: $("#bottomsheet-container"),
      content: $("#bottomsheet-content"),
      title: $("#bottomsheet-title"),
      closeBtn: $("#bottomsheet-close"),
      dragHandle: $("#bottomsheet-drag-handle")
    };
    if (!els.container) return;
    els.closeBtn?.addEventListener("click", close);
    els.backdrop?.addEventListener("click", close);
    els.dragHandle?.addEventListener("mousedown", handleDragStart);
    els.dragHandle?.addEventListener("touchstart", handleDragStart, { passive: true });
    document.addEventListener("mousemove", handleDragMove);
    document.addEventListener("touchmove", handleDragMove, { passive: false });
    document.addEventListener("mouseup", handleDragEnd);
    document.addEventListener("touchend", handleDragEnd);
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && state.isOpen) close();
    });
  };
  const open = (options = {}) => {
    init();
    if (!els.container || !els.backdrop) return;
    state.previousFocus = document.activeElement;
    state.onCloseCallback = options.onClose || null;
    if (options.title && els.title) els.title.textContent = options.title;
    if (options.content && els.content) els.content.innerHTML = options.content;
    els.backdrop.classList.remove("hidden");
    requestAnimationFrame(() => {
      els.backdrop.classList.remove("opacity-0");
      els.backdrop.classList.add("opacity-100");
      els.container.classList.remove("translate-y-full");
    });
    state.isOpen = true;
    document.body.style.overflow = "hidden";
    setTimeout(() => {
      const firstFocusable = els.container.querySelector(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
      );
      firstFocusable?.focus();
    }, 300);
    if (globalThis.lucide) lucide.createIcons({ nodes: els.content.querySelectorAll("[data-lucide]") });
    State.ui?.set("bottomsheetOpen", true);
  };
  const close = () => {
    if (!els?.container || !state.isOpen) return;
    els.container.style.transition = "";
    els.container.style.transform = "";
    els.container.classList.add("translate-y-full");
    els.backdrop.classList.remove("opacity-100");
    els.backdrop.classList.add("opacity-0");
    setTimeout(() => {
      els.backdrop.classList.add("hidden");
      if (els.content) els.content.innerHTML = "";
      document.body.style.overflow = "";
      state.isOpen = false;
      state.onCloseCallback?.();
      state.onCloseCallback = null;
      state.previousFocus?.focus();
    }, 300);
    State.ui?.set("bottomsheetOpen", false);
  };
  const handleDragStart = (e) => {
    if (!state.isOpen) return;
    state.isDragging = true;
    state.startY = e.touches ? e.touches[0].clientY : e.clientY;
    els.container.style.transition = "none";
  };
  const handleDragMove = (e) => {
    if (!state.isDragging) return;
    const clientY = e.touches ? e.touches[0].clientY : e.clientY;
    state.currentY = clientY - state.startY;
    if (state.currentY > 0) {
      els.container.style.transform = `translateY(${state.currentY}px)`;
      if (e.cancelable) e.preventDefault();
    }
  };
  const handleDragEnd = () => {
    if (!state.isDragging) return;
    state.isDragging = false;
    els.container.style.transition = "";
    if (state.currentY > 100) {
      close();
    } else {
      els.container.style.transform = "";
    }
    state.currentY = 0;
  };
  const isOpen = () => state.isOpen;
  const setContent = (html) => {
    if (els?.content) {
      els.content.innerHTML = html;
      if (globalThis.lucide) lucide.createIcons({ nodes: els.content.querySelectorAll("[data-lucide]") });
    }
  };
  return Object.freeze({
    init,
    open,
    close,
    isOpen,
    setContent
  });
})();
